export const forgotPasswordResourceType = 'forgot_password_request';
export const forgotPasswordResourcePath = '/forgot_password';
